import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDataCatalogLineageDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      d="M18 5H5c-.5 0-1 .4-1 1v13c0 .5.5 1 1 1h13c.6 0 1-.5 1-1V6c0-.6-.5-1-1-1zm0 7h-6V6h6v6zm-7-6v6H5V6h6zm-6 7h6v6H5v-6zm7 6v-6h6v6h-6z"
      style={{
        fill: "#666",
      }}
    />
  </svg>
);
const Memo = memo(SvgDataCatalogLineageDashboard);
export default Memo;
